import * as React from "react";
import { Typography, TextField } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles({
  pgcNameField: {
    marginBottom: "1rem",
  },
  modalHeaderText: {
    paddingBottom: 0,
  },
});

interface Props {
  value: string;
  onChange: (value: string) => void;
  header: string;
  errors?: boolean;
  errorText?: string;
  width?: "small" | "large" | "medium";
  displayTextField?: boolean;
}

export default function SaveNameInput({
  value,
  onChange,
  header,
  errors,
  errorText,
  width,
  displayTextField,
}: Props) {
  const classes = useStyles();

  const getWidth = () => {
    const values = {
      small: 200,
      medium: "95%",
      large: 600,
    };
    return width ? values[width] : 400;
  };
  return (
    <>
      <Typography
        variant="body2"
        color="primary"
        className={classes.modalHeaderText}
      >
        <b>{header}</b> {!displayTextField && "(shorter names display better)"}
      </Typography>
      {!displayTextField && (
        <TextField
          size="small"
          margin="dense"
          style={{ width: getWidth() }}
          className={classes.pgcNameField}
          label="Enter Name"
          variant="outlined"
          value={value}
          error={errors}
          onChange={(e: any) => onChange(e.target.value)}
          helperText={errorText}
          id="input-name-field"
        />
      )}
    </>
  );
}
